export function getMeetAges(args: {
  minAge: number;
  maxAge: number;
  short?: boolean;
}) {
  let result = `${args.minAge}-${args.maxAge}`;

  if (
    (args.minAge === 0 && args.maxAge === 109) ||
    (!args.minAge && !args.maxAge)
  ) {
    result = "Open";
  }

  if (args.minAge > 0 && args.maxAge === 109) {
    if (args.short) {
      result = `${args.minAge}&O`;
    } else {
      result = `${args.minAge} & Over`;
    }
  }

  if (args.minAge === 0 && args.maxAge < 109) {
    if (args.short) {
      result = `${args.maxAge}&U`;
    } else {
      result = `${args.maxAge} & Under`;
    }
  }

  if (args.minAge && args.minAge === args.maxAge) {
    result = args.minAge.toString();
  }

  return result;
}
